module.exports = __webpack_public_path__ + "img/sixpackcarrier27.8780c6c0.jpg";